module.exports = __webpack_public_path__ + "media/Video 86.f77fe892.mp4";